export default __webpack_public_path__ + "static/media/DSCN6692.74811c5e.JPG";